// api接口的统一出口

// 登录模块接口
import login from '@/api/login'
// 菜单模块接口
import menu from '@/api/menu'
// 用户权限模块接口
import userPermission from '@/api/userPermission'
// 白名单模块接口
import whitelist from '@/api/whitelist'
// 信息集模块的接口
import infoItem from '@/api/infoItem'
// 系统配置模块的接口
import systemConfig from '@/api/systemConfig'

// 暴露接口
export default {
  login,
  menu,
  userPermission,
  whitelist,
  infoItem,
  systemConfig
  // ……
}



// WEBPACK FOOTER //
// ./src/api/index.js